/**
 * @generated SignedSource<<2a0643c7748ac709ee5818f3aed284e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PROJECT_STATUS = "OPPORTUNITY" | "PLANNING" | "RUNNING" | "HALTED" | "DONE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AllPhasesDropdown_projects$data = ReadonlyArray<{
  readonly node: {
    readonly id: string;
    readonly name: string | null;
    readonly projectColor: string | null;
    readonly companyProjectId: number | null;
    readonly status: PROJECT_STATUS | null;
  } | null;
  readonly " $fragmentType": "AllPhasesDropdown_projects";
}>;
export type AllPhasesDropdown_projects$key = ReadonlyArray<{
  readonly " $data"?: AllPhasesDropdown_projects$data;
  readonly " $fragmentSpreads": FragmentRefs<"AllPhasesDropdown_projects">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "AllPhasesDropdown_projects",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "companyProjectId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectTypeEdge",
  "abstractKey": null
};

(node as any).hash = "06a49f920986d20a87a5fde27c7186a8";

export default node;
